import { Tooltip } from '@systemeio/ui'
import { ContactTagInterface } from 'modules/contacts/types/contact-interface'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface ContactTagBubbleProps {
  tags: ContactTagInterface[]
}

const ContactTagBubbles = ({ tags }: ContactTagBubbleProps) => {
  const { t } = useLocoTranslation()
  return (
    <ul className={'flex flex-wrap gap-3'}>
      {tags.slice(0, 2).map(el => (
        <li
          key={el.id}
          className={'bg-background-primary text-text-primary h-fit rounded-full px-3 py-1.5'}
        >
          {el.name}
        </li>
      ))}
      {tags.length > 2 && (
        <Tooltip
          stayOnHover={true}
          popoverClassName={'p-0'}
          anchor={{ to: 'top' }}
          label={
            <div className="bg-background-secondary shadow-3xl z-50 rounded-lg">
              <div
                className={` bg-background-secondary relative w-fit max-w-[400px] whitespace-normal rounded-lg px-5 py-3`}
              >
                <div className="text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium">
                  <ul className={'flex w-full flex-wrap gap-3'}>
                    {tags.slice(2).map(el => (
                      <li
                        key={el.id}
                        className={
                          'bg-background-primary text-text-primary h-fit rounded-full px-3 py-1.5'
                        }
                      >
                        {el.name}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          }
        >
          {show => (
            <button
              type="button"
              className={`main-transition-colors bg-background-primary text-text-primary hover:bg-brand-primary hover:text-background-secondary focus-visible:bg-brand-primary focus-visible:text-background-secondary rounded-full px-3 py-1.5 outline-hidden ${
                show && 'bg-brand-primary text-background-secondary'
              }`}
            >
              {t('dashboard.contacts.plus_more_tags', {
                count: tags.length - 2,
              })}
            </button>
          )}
        </Tooltip>
      )}
    </ul>
  )
}

export default ContactTagBubbles
